import { makeActionFactory } from './actionFactory';
import { DeviceGroupMap } from 'types';

export type ActionType =
    'DEVICEGROUPS_LOAD_REQUEST'
    | 'DEVICEGROUPS_LOAD_SUCCESS'
    | 'DEVICEGROUPS_LOAD_FAILURE'
    | 'DEVICEGROUPS_CHANGED'
;

const actionFactory = makeActionFactory<ActionType>();


//
//  DEVICEGROUPS_LOAD_REQUEST action notifies the app that we're trying to load deviceGroups
//
export interface DeviceGroupsLoadRequestAction {
    type: 'DEVICEGROUPS_LOAD_REQUEST';
}
export const deviceGroupsLoadRequest = actionFactory.empty<DeviceGroupsLoadRequestAction>('DEVICEGROUPS_LOAD_REQUEST');


//
//  DEVICEGROUPS_LOAD_SUCCESS action notifies the app that we successfully loaded deviceGroups
//
export interface DeviceGroupsLoadSuccessAction {
    type: 'DEVICEGROUPS_LOAD_SUCCESS';
    payload: DeviceGroupMap;
}
export const deviceGroupsLoadSuccess = actionFactory.payload<DeviceGroupsLoadSuccessAction, DeviceGroupMap>('DEVICEGROUPS_LOAD_SUCCESS');


//
//  DEVICEGROUPS_LOAD_FAILURE action notifies the app that we failed to load deviceGroups
//
export interface DeviceGroupsLoadFailureAction {
    type: 'DEVICEGROUPS_LOAD_FAILURE';
    payload: Error;
    error: true;
}
export const deviceGroupsLoadFailure = actionFactory.error<DeviceGroupsLoadFailureAction>('DEVICEGROUPS_LOAD_FAILURE');


//
//  DEVICEGROUP_CHANGED action notifies the app that deviceGroups have changed
//  (asynchronously via server push rather than us loading them)
//
export type DeviceGroupDelta = {}; // TODO: ...
export interface DeviceGroupsChangedAction {
    type: 'DEVICEGROUPS_CHANGED';
    payload: DeviceGroupDelta[];
}
export const deviceGroupsChanged = actionFactory.payload<DeviceGroupsChangedAction, DeviceGroupDelta[]>('DEVICEGROUPS_CHANGED');



// WEBPACK FOOTER //
// ./src/actions/deviceGroupActions.ts